import '~/assets/scss/news-page.scss'


import initSocials from '~/js/modules/init-socials';
import convertDate from '~/js/modules/date';
import Accordion from '~/js/modules/accordion';

window.addEventListener(`DOMContentLoaded`, () => {
  initSocials();
  //convertDate();

  const winHeight = scrollY
  const docHeight = document.querySelector('.info-content__content').scrollHeight
  const progressBar = document.querySelector('progress')
  const max = docHeight - winHeight
  let value = document.documentElement.scrollTop

  progressBar.setAttribute('max',max)
  progressBar.setAttribute('value',value)

  window.addEventListener('scroll', function() {
      progressBar.setAttribute('value',scrollY)
  })

  const accordions = document.querySelectorAll(`.accordion`);

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list')) {
        new Accordion(accordion)
      }
    });
  }

  const dropdown = document.querySelectorAll(`.js-dropdown`);
  if (dropdown.length) {
    dropdown.forEach((drop) => {
      drop.addEventListener('click', function() {
        document.querySelector('#'+drop.dataset.dropdown).classList.toggle('active')
      })
    });
  }
  document.addEventListener('click', function (e) {
    if (dropdown.length) {
      dropdown.forEach((drop) => {
        if (e.target != drop && !document.querySelector('#'+drop.dataset.dropdown).contains(e.target)){
          document.querySelector('#'+drop.dataset.dropdown).classList.remove('active')
        }
      })
    }
  });

  const socials = document.querySelectorAll('.js-copy_link')
  socials.forEach((soc) => {
    soc.addEventListener('click', function (event) {
      event.preventDefault();
      let url = soc.getAttribute('data-url');
      let textArea = document.createElement("textarea");
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      let successful = document.execCommand('copy');
      soc.querySelector('.clr-text').innerHTML = "Скопировано!";
      setTimeout(function(){
        soc.querySelector('.clr-text').innerHTML = "Скопировать ссылку"
      }, 3000)
      document.body.removeChild(textArea);
      return;
    })
  })
  const like = document.querySelectorAll('.js-xlike-button')
  like.forEach((lk) => {
    lk.addEventListener('click', function (event) {
      like.forEach((el) => {
        if(el != lk) {
          el.classList.toggle('xlike__link_active')
        }
      })
    })
  })
  const close_btn = document.querySelectorAll('.js-close-btn')
  if (close_btn) {
    close_btn.forEach((el) => {
      el.addEventListener('click', () => {
        el.parentNode.remove()
      })
    })
  }

  const openForm = document.querySelectorAll('.js-blog-open-form')
  if (openForm) {
    openForm.forEach((of) => {
      of.addEventListener('submit', function (e) {
        e.preventDefault()
        const formData = new FormData(of);
        if(formData.get('surname').length < 2) {
          of.querySelector('.surname').classList.add('invalid')
        }
        if(formData.get('name').length < 2) {
          of.querySelector('.name').classList.add('invalid')
        }
        /*if(formData.get('patronymic').length == 1) {
          of.querySelector('.patronymic').classList.add('invalid')
        }*/
        if(formData.get('phone').length < 11) {
          of.querySelector('.open-phone').classList.add('invalid')
          of.querySelector('.open-phone').dataset.invalid = 'Это поле должно быть не меньше 11 символов'
        }
        if(formData.get('questionPersonalData[]') == '') {
          of.querySelector('.questionPersonalData').classList.add('invalid')
        }
        of.querySelector('.kids-check').classList.remove('invalid')
        if(of.querySelectorAll('.invalid').length > 0) {
          return
        }
        let action
        if(formData.has('kids[]')) {
          action = of.dataset.action + 'opif-otkryt-schet-na-rebenka'
          ym(10543570,'reachGoal','openaccountclickformkidblog')
        }
        else {
          action = of.dataset.action + 'pif'
          ym(10543570,'reachGoal','openaccountclickformblog')
        }
        of.action = action
        of.submit()
      })
    })
  }
});
